export default {
      id: "computer-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#computer",
      toString: function () {
        return this.url;
      }
    }